import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button.tsx';
import { buildPhotosUrl } from './helpers/buildPhotosUrl.ts';

import styles from './RelatedPhotosViewAllButton.scss';

import { type PhotoTagType } from './types.ts';

type Props = {
    isMobile: boolean;
    styleTag?: PhotoTagType | null;
    roomTag?: PhotoTagType | null;
    numberOfPages: number;
};

const RelatedPhotosViewAllButton: FC<Props> = props => {
    const { isMobile, styleTag, roomTag, numberOfPages } = props;
    const styleTagName = styleTag?.name || '';
    const roomTagName = roomTag?.name || '';

    let photosUrl = buildPhotosUrl(styleTag?.urlLabel, roomTag?.urlLabel);

    if (numberOfPages > 1) {
        const [baseUrl, params] = photosUrl.split('?');
        const urlParams = new URLSearchParams(params);
        urlParams.set('page', '2');
        photosUrl = `${baseUrl}?${urlParams.toString()}`;
    }

    return (
        <Button
            className={styles.button}
            type="secondary"
            size={isMobile ? 'small' : 'large'}
            href={photosUrl}
        >
            {styleTagName || roomTagName ? (
                <FormattedMessage
                    id="interiorPhoto.relatedPhotos.viewAll"
                    defaultMessage="View All {displayName} Photos"
                    values={{ displayName: `${styleTagName} ${roomTagName}` }}
                />
            ) : (
                <FormattedMessage
                    id="interiorPhoto.relatedPhotos.viewAllFalback"
                    defaultMessage="View All Rooms"
                />
            )}
        </Button>
    );
};

export default RelatedPhotosViewAllButton;
